import UserUnsubscription from '@nollaSdk/models/UserUnsubscription'
import {
  ADD_ITEM_TO_LIST, DELETE_ITEM_FROM_LIST, SET_ITEM, ADD_LIST,
} from '../core/mutation-types'
import mutations from '../core/mutations'

const state = {
  initialState() {
    return {
      list: [],
      item: null,
    }
  },
  list: [],
  item: null,
}

// actions
const actions = {
  delete({ commit }, id) {
    return UserUnsubscription.delete(id)
      .then(() => {
        commit(SET_ITEM, null)
        commit(DELETE_ITEM_FROM_LIST, id)
        return true
      })
  },
  get({ commit }, id) {
    return UserUnsubscription.find(id)
      .then(model => {
        commit(SET_ITEM, model)
        if (model) {
          commit(ADD_ITEM_TO_LIST, model)
        }
        return model
      })
  },
  getList({ commit }, params) {
    return UserUnsubscription.search(params)
      .then(models => {
        commit(ADD_LIST, models)
        return models
      })
  },
  post({ commit }, params) {
    return UserUnsubscription.post(params)
      .then(model => {
        commit(SET_ITEM, model)
        if (model) {
          commit(ADD_ITEM_TO_LIST, model)
        }
        return model
      })
  },
  put({ commit }, payload) {
    return UserUnsubscription.put(payload.id, payload.params)
      .then(model => {
        commit(SET_ITEM, model)
        if (model) {
          commit(ADD_ITEM_TO_LIST, model)
        }
        return model
      })
  },
}

export default {
  actions,
  mutations,
  namespaced: true,
  state,
}
